export default {
  namespaced: true,
  state: {
    hasNoInternet: false,
  },
  getters: {
    getInternetStatus(state) {
      return state.hasNoInternet;
    },
  },
  mutations: {
    SET_INTERNET_STATUS(state, value) {
      state.hasNoInternet = value;
    },
  },
  actions: {
    setInternetStatus({ commit }, value) {
      commit('SET_INTERNET_STATUS', value);
    },
  },
};
